import { render, staticRenderFns } from "./TypeSettingsPanel.vue?vue&type=template&id=34f89df0"
import script from "./TypeSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./TypeSettingsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports